module.exports = "<div class=\"col-sm-9 col-md-10 main\">\n\t<h1 class=\"page-header\">Start of Day Asset Position Event Log</h1>\n\t<div id='jqxWidget'\tstyle=\"font-size: 13px; font-family: Verdana; float: left; width: 100%; height: 50%;\">\n\t\t<div id=\"jqxgrid\"></div>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/sod-assets-h/sod-assets-h.component.html
// module id = ../../../../../src/app/pages/history/sod-assets-h/sod-assets-h.component.html
// module chunks = main